import { ReactNode, useMemo, useState } from 'react';
import { FormSearchContext } from './FormSearchContext';

/**
 * Holds the card form's field search above the form, which remounts for each card. Placed by
 * whatever owns the form's lifetime, beside its FormScrollProvider: the card modal keeps one
 * across next/prev, so the same fields stay in view from card to card.
 */
export function FormSearchProvider({ children }: { children: ReactNode }) {
  const [query, setQuery] = useState('');
  const value = useMemo(() => ({ query, setQuery }), [query]);
  return <FormSearchContext.Provider value={value}>{children}</FormSearchContext.Provider>;
}
